define([
    "underscore",
    "backbone",
    "backbone.form"
], function (_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_account/validate_internal_transfer_requests",

        validation: {
            from_mt4: {
                min: 10000,
                differentFrom: 'to_mt4',
            },
            to_mt4: {
                min: 10000,
                differentFrom: 'from_mt4'
            },
            amount: {
                required: true,
                pattern: 'number'
            }
        }
    });
});